package com.techspiration.webuserapp.legal

import androidx.compose.runtime.Composable
import com.techspiration.webuserapp.site.SectionContainer
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/**
 * Kullanım Şartları (Terms of Use / EULA) — App Store Connect "App Description" linki ve
 * uygulama içi abonelik ekranından (Guideline 3.1.2(c)) referans verilen sayfa.
 */
@Composable
fun TermsScreen() {
    SectionContainer {
        H1(attrs = { classes("t-h1") }) { Text("Kullanım Şartları") }
        P(attrs = { classes("t-label") }) { Text("Son güncelleme: 16 Haziran 2026") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Bu Kullanım Şartları, KamuApp (Atama Bildirim — Kamu İlanları) uygulamasını " +
                    "(\"Uygulama\") kullanımınızı düzenler. Uygulamayı kullanarak bu şartları kabul etmiş sayılırsınız.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Hizmet Tanımı") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Uygulama, Kariyer Kapısı ve İŞKUR gibi resmi kaynaklardan derlenen kamu ilanlarını " +
                    "listeler, bildirim gönderir ve kullanıcıya özel favori/başvuru takibi sağlar. Uygulama " +
                    "resmi bir devlet kurumu değildir ve bu kurumlarla iştirak ilişkisi yoktur.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Abonelik ve Ücretlendirme") }
        Ul {
            Li { Text("Premium abonelik, App Store üzerinden satın alınan otomatik yenilenen bir abonelik hizmetidir.") }
            Li { Text("Abonelik süresi ve fiyatı satın alma ekranında (App Store onaylı) açıkça gösterilir.") }
            Li {
                Text(
                    "Abonelik, mevcut dönem bitmeden en az 24 saat önce iptal edilmediği sürece OTOMATİK olarak " +
                        "yenilenir; yenileme ücreti dönem bitiminden önceki 24 saat içinde hesabınızdan tahsil edilir.",
                )
            }
            Li { Text("Abonelik iptali ve yönetimi App Store hesap ayarlarınızdan yapılır; uygulama içinden ödeme iadesi yapılmaz.") }
            Li { Text("Kullanılmayan süre için kısmi iade yapılmaz; iade talepleri Apple'ın App Store politikalarına tabidir.") }
        }

        H2(attrs = { classes("t-h2") }) { Text("Kullanıcı Yükümlülükleri") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Uygulamayı yalnızca hukuka uygun amaçlarla kullanmayı, hesap bilgilerinizin gizliliğini " +
                    "korumayı ve üçüncü kişilerin haklarını ihlal etmemeyi kabul edersiniz.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Fikri Mülkiyet") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Uygulamadaki tasarım, yazılım ve marka unsurları Techspiration'a aittir. İlan içerikleri " +
                    "ilgili kamu kurumlarına aittir ve yalnızca bilgilendirme amacıyla derlenmiştir.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Sorumluluk Sınırlaması") }
        P(attrs = { classes("t-body") }) {
            Text(
                "Uygulama, ilan bilgilerinin güncelliğini korumak için çaba gösterir ancak resmi kaynaklardaki " +
                    "değişikliklerden kaynaklanan hata veya gecikmelerden sorumlu tutulamaz. Başvuru işlemleri " +
                    "ilgili kurumun resmi platformu üzerinden tamamlanmalıdır.",
            )
        }

        H2(attrs = { classes("t-h2") }) { Text("Değişiklikler") }
        P(attrs = { classes("t-body") }) { Text("Bu şartlar zaman zaman güncellenebilir; güncel sürüm bu sayfada yayınlanır.") }

        H2(attrs = { classes("t-h2") }) { Text("İletişim") }
        P(attrs = { classes("t-body") }) { Text("Sorularınız için: kamuapp@techspiration.me") }
    }
}
